var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransportRentalScooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.019 3.959h3.724a2.262 2.262 0 0 1 2.193-1.744c1.056 0 1.954.74 2.192 1.744h3.725a.53.53 0 0 1 .528.528.53.53 0 0 1-.528.528h-3.725a2.241 2.241 0 0 1-.66 1.136l3.38.951v8.532s.212 2.88-2.826 2.906v-1.902a2.074 2.074 0 0 0-2.086-2.087 2.074 2.074 0 0 0-2.087 2.087v1.902c-3.038-.027-2.826-2.906-2.826-2.906V7.102l3.38-.925a2.242 2.242 0 0 1-.66-1.135H6.02a.53.53 0 0 1-.529-.528c-.026-.318.238-.555.529-.555zm5.917-.74c-.714 0-1.268.581-1.268 1.268s.554 1.294 1.268 1.294c.713 0 1.268-.58 1.268-1.267 0-.687-.555-1.295-1.268-1.295z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.936 15c.898 0 1.637.74 1.637 1.638v3.724c0 .898-.74 1.638-1.637 1.638-.898 0-1.638-.74-1.638-1.638v-3.724c0-.898.74-1.638 1.638-1.638z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportRentalScooter);
export default __webpack_public_path__ + "static/media/transport-rental-scooter.55ccab55356dddd990d6afc19d19e56c.svg";
export { ForwardRef as ReactComponent };